<template>

    <div>
        <h4 class="mb-2">Adopted workers</h4>

        <vx-card>
            <vs-table id="table" ref="table" @selected="openWorker" v-model="selected" pagination :max-items="itemsPerPage" search :data="tableData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="cpu">CPU</vs-th>
                    <vs-th sort-key="status">Status</vs-th>
                    <vs-th sort-key="ip">IP</vs-th>
                    <vs-th sort-key="port">Port</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                            <vs-td :data="data[index].cpu">
                                {{ data[index].cpu }}
                            </vs-td>

                            <vs-td v-if="data[index].adoption_status !== 8" :data="data[index].adoption_status">
                                <vs-chip color="warning">Adopting</vs-chip>
                            </vs-td>

                            <vs-td v-else :data="data[index].status" class="flex">

                                <div  style="display: flex" v-if="data[index].status === 1">
                                    <vs-chip style="float: left" color="success">Online</vs-chip>
                                    <vx-tooltip text="No remote access" style="float: left" v-if="data[index].remote_access_status === 0"><feather-icon style="color:#FF9F43" icon="AlertTriangleIcon" class="ml-2 cursor-pointer"/></vx-tooltip>
                                </div>

                                <vs-chip v-else color="danger">Offline</vs-chip>

                                <vx-tooltip text="Disabled because of license limit" style="float: left" v-if="data[index].license_disabled"><feather-icon style="color:#EA5455" icon="AlertOctagonIcon" color="danger" class="ml-2 cursor-pointer"/></vx-tooltip>

                            </vs-td>

                            <vs-td :data="data[index].ip">
                                {{ data[index].ip }}
                            </vs-td>

                            <vs-td :data="data[index].port">
                                {{ data[index].port }}
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

    </div>
</template>
<script>
    export default {

        data() {
            return {

                selected: {},
                itemsPerPage: 100,
                isMounted: false,

                workers: [],

                updateDataTimer: '',
                initialLoadFinished: false

            }
        },
        methods: {
            openWorker() {
                if (this.selected.adoption_status !== 8) {
                    this.$router.push('/worker/adopt/' + this.selected.id + '/status')
                    return
                }

                this.$router.push('/worker/' + this.selected.id)
            },
            loadData() {
                if (!this.initialLoadFinished) {
                    this.$vs.loading({
                        container: '#table',
                        type: 'corners',
                        scale: 0.7
                    })
                }

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/?type=adopted')
                loadPromise.then(function(response) {
                    thisIns.workers = response.data
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.initialLoadFinished = true
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                const data = []

                for (let i = 0; i < this.workers.length; i++) {
                    data.push({
                        id: this.workers[i].id,
                        name: this.workers[i].name,
                        cpu: this.workers[i].cpu,
                        ip: this.workers[i].ip,
                        port: this.workers[i].port,
                        adoption_status: this.workers[i].adoption_status,
                        status: this.workers[i].status,
                        remote_access_status: this.workers[i].remote_access_status,
                        license_disabled: this.workers[i].license_disabled
                    })
                }

                return data
            }
        },
        beforeDestroy() {
            clearInterval(this.updateDataTimer)
        },
        mounted() {
            this.isMounted = true
            this.loadData()
            this.updateDataTimer = setInterval(() => { this.loadData() }, 3000)
        }

    }
</script>
